import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";
import {
  GoogleGenerativeAI,
  GenerativeModel,
  GenerateContentRequest,
} from "@google/generative-ai";

export interface ChatMessage {
  role: "user" | "model";
  content: string;
  hidden?: boolean;
}

@Injectable({ providedIn: "root" })
export class GenAiService {
  private model: GenerativeModel | null = null;

  private ensureModel() {
    const key = environment.genAi.apiKey;
    if (!key) return null;
    if (!this.model) {
      const client = new GoogleGenerativeAI(key);
      this.model = client.getGenerativeModel({ model: "gemini-2.5-flash" });
    }
    return this.model;
  }

  // Unified structured generate method
  async generate(
    messages: ChatMessage[],
    systemInstruction: string,
  ): Promise<string> {
    const model = this.ensureModel();
    if (!model) return "GenAI API key not set.";
    try {
      if (!messages?.length) return "No messages provided.";
      const contents = messages.map((m) => ({
        role: m.role,
        parts: [{ text: m.content }],
      }));
      const request: GenerateContentRequest = {
        systemInstruction,
        contents,
      };
      const result = await model.generateContent(request);
      const candidates = result?.response?.candidates || [];
      for (const c of candidates) {
        const parts = c?.content?.parts || [];
        const text = parts
          .map((p) => (p as any).text)
          .filter((t) => !!t)
          .join("\n")
          .trim();
        if (text) return text;
      }
      return "<Done>";
    } catch (e: any) {
      console.error("GenAI generate error", e);
      return e?.message || "Generation error.";
    }
  }
}
